import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../interface/benefit-activation-dialog.extension.interface';
import { BenefitInfoTextExtensionInterface } from '../interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../interface/benefit-navigation.extension.interface';
import { RoutesExtensionInterface } from '../interface/routes.extension.interface';
import { BikeleasingBenefitActivationDialogExtension } from './bikeleasing-benefit-activation-dialog.extension';
import { BikeleasingBenefitInfoTextExtension } from './bikeleasing-benefit-info-text.extension';
import { BikeleasingBenefitMetadataExtension } from './bikeleasing-benefit-metadata.extension';
import { BikeleasingBenefitNavigationExtension } from './bikeleasing-benefit-navigation.extension';
import { BikeleasingRoutesExtension } from './bikeleasing.routes.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('bikeleasing')
    .add(BenefitMetadataExtensionInterface, new BikeleasingBenefitMetadataExtension())
    .add(RoutesExtensionInterface, new BikeleasingRoutesExtension())
    .add(BenefitNavigationExtensionInterface, new BikeleasingBenefitNavigationExtension())
    .add(BenefitActivationDialogExtensionInterface, new BikeleasingBenefitActivationDialogExtension())
    .add(BenefitInfoTextExtensionInterface, new BikeleasingBenefitInfoTextExtension())
    .build(),
);
